(function () {
  var LABEL_TEXT = 'Delivery & pickup options';
  var STORAGE_KEY = 'hs-zapiet-collapsed';

  function setVisibility(wrapper, target) {
    var hasContent = target.children.length > 0 || target.textContent.trim() !== '';
    wrapper.style.display = hasContent ? '' : 'none';
  }

  function settleOverflow(wrapper) {
    var body = wrapper.querySelector('.zapiet-collapse__body');
    if (!body) return;
    body.addEventListener('transitionend', function handler(e) {
      if (e.propertyName !== 'grid-template-rows') return;
      if (!wrapper.classList.contains('is-collapsed')) {
        wrapper.classList.add('is-expanded-settled');
      }
    });
  }

  function buildWrapper(target) {
    if (target.closest('.zapiet-collapse')) return;

    var wrapper = document.createElement('div');
    wrapper.className = 'zapiet-collapse is-expanded-settled';

    var toggle = document.createElement('button');
    toggle.type = 'button';
    toggle.className = 'zapiet-collapse__toggle';
    toggle.setAttribute('aria-expanded', 'true');
    toggle.innerHTML =
      '<span>' + LABEL_TEXT + '</span>' +
      '<svg class="zapiet-collapse__icon" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">' +
      '<path d="M5 7.5L10 12.5L15 7.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>';

    var body = document.createElement('div');
    body.className = 'zapiet-collapse__body';
    var bodyInner = document.createElement('div');
    bodyInner.className = 'zapiet-collapse__body-inner';
    body.appendChild(bodyInner);

    target.parentNode.insertBefore(wrapper, target);
    bodyInner.appendChild(target);
    wrapper.appendChild(toggle);
    wrapper.appendChild(body);

    settleOverflow(wrapper);

    var collapsed = false;
    try { collapsed = sessionStorage.getItem(STORAGE_KEY) === '1'; } catch (e) {}
    if (collapsed) {
      wrapper.classList.add('is-collapsed');
      wrapper.classList.remove('is-expanded-settled');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      var willCollapse = !wrapper.classList.contains('is-collapsed');
      if (willCollapse) {
       
        wrapper.classList.remove('is-expanded-settled');
        requestAnimationFrame(function () {
          wrapper.classList.add('is-collapsed');
        });
      } else {
        wrapper.classList.remove('is-collapsed');
      }
      toggle.setAttribute('aria-expanded', String(!willCollapse));
      try { sessionStorage.setItem(STORAGE_KEY, willCollapse ? '1' : '0'); } catch (e) {}
    });

    
    setVisibility(wrapper, target);
    var contentObserver = new MutationObserver(function () {
      setVisibility(wrapper, target);
    });
    contentObserver.observe(target, { childList: true, subtree: true });
  }

  function scan(root) {
    root.querySelectorAll('#storePickupApp, [id^="storePickupApp"]').forEach(buildWrapper);
  }

  scan(document);

  var observer = new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.id === 'storePickupApp') buildWrapper(node);
        else if (node.querySelector) scan(node);
      });
    });
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();